// extracted by mini-css-extract-plugin
export default {"root":"AvatarSelection_root__RA8t-","layout-container":"AvatarSelection_layout-container__CoBiM","avatarsContainer":"AvatarSelection_avatarsContainer__qYerQ","avatars":"AvatarSelection_avatars__-Fs4K","spinnerWrapper":"AvatarSelection_spinnerWrapper__WHemQ","overlayFade":"AvatarSelection_overlayFade__I1GnF","overlayHidden":"AvatarSelection_overlayHidden__rqbvL","avatarsWrapper":"AvatarSelection_avatarsWrapper__L7I6g"};
    if(module.hot) {
      // 1763464084905
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  